import React from 'react';
import styled from 'styled-components';
import {
  BREAKPOINT_DESKTOP,
  HEIGHT_MOBILE as HEADER_HEIGHT_MOBILE,
  HEIGHT_DESKTOP as HEADER_HEIGHT_DESKTOP,
} from 'packages/smart-home-support/components/Header/constants';
import { Fade } from 'packages/smart-home-support/components/transitions';

type ToastProps = {
  show?: boolean;
  topOffset?: number;
};

const s = {
  Container: styled(Fade)<{ topOffset: number }>`
    position: fixed;
    display: flex;
    box-sizing: border-box;
    align-items: center;
    margin: 0 auto;
    margin-top: 10px;
    top: ${(props) => HEADER_HEIGHT_MOBILE + props.topOffset}px
    left: 12px;
    right: 12px;
    background: #fff;
    padding: 18px;
    border: 1px solid #57c880;
    border-radius: 8px;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);
    font-size: 14px;
    z-index: 10;
    max-width: 1200px;
    @media ${BREAKPOINT_DESKTOP} {
      top: ${(props) => HEADER_HEIGHT_DESKTOP + props.topOffset}px
    }
  `,
  Icon: styled.div`
    width: 20px;
    height: 20px;
    margin-right: 10px;
  `,
};

const Toast: React.FC<ToastProps> = (props) => {
  const { children, show = false, topOffset = 0 } = props;
  return (
    <s.Container in={show} timeout={500} topOffset={topOffset}>
      <s.Icon>
        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M10.042 0.944336C4.51899 0.944336 0.0419922 5.42134 0.0419922 10.9443C0.0419922 16.4673 4.51899 20.9443 10.042 20.9443C15.565 20.9443 20.042 16.4673 20.042 10.9443C20.042 5.42134 15.564 0.944336 10.042 0.944336ZM9.29199 16.6943L4.29199 12.9443L5.79199 10.9443L8.79199 13.1943L14.042 6.19434L16.042 7.69434L9.29199 16.6943Z"
            fill="#57C880"
          />
        </svg>
      </s.Icon>
      <div>{children}</div>
    </s.Container>
  );
};

export default Toast;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/Toast.tsx